import {
  TnplAcceptableRiskLevel,
  type TnplShippingPolicy,
} from "@redotech/redo-model/team";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getTryFirstPlan = {
  name: "getTryFirstPlan" as const,
  // No input parameters needed - we'll get the plan for the current team
  input: z.object({}),

  // Output schema with plan details
  output: z.object({
    planExists: z.boolean(),
    plan: z
      .object({
        id: z.string(),
        name: z.string(),
        productIds: z.array(z.number()),
        trialLength: z.number(),
        trialEndChargeDelay: z.number().optional(),
        cartValueLimit: z.number().optional(),
        cartMaxTnplItems: z.number().optional(),
        sellingPlanId: z.number().optional(),
        shippingPolicy: z.custom<TnplShippingPolicy>().optional(),
        createdAt: z.string(),
        updatedAt: z.string(),
      })
      .optional(),
    acceptableOrderRisk: createEnum(TnplAcceptableRiskLevel).optional(),
    useMinutesForTrialPeriod: z.boolean().optional(),
    tnplOrderTags: z
      .object({
        enabled: z.boolean(),
        onCreated: z.array(z.string()),
        onAuthorized: z.array(z.string()),
        onStart: z.array(z.string()),
      })
      .optional(),
    shopDomain: z.string().optional(),
  }),
};
